import React from 'react';

import { useIntl } from 'react-intl';
import { toSnakeTrimmed } from '~/utils/strings';

import ActionsMenu from '../ActionsMenu/ActionsMenu';

export default function SelectDeselectAllMenu({ name, onChange }) {
  const intl = useIntl();
  const menuName = name + '_select menu';
  const id = toSnakeTrimmed(menuName);
  function getSelectAllMenuItems() {
    const items = [];

    items.push(
      {
        content: intl.formatMessage({
          id: 'SelectDeselectAllMenu.selectAll',
          defaultMessage: 'Select All',
          description: 'Menu option to select all items',
        }),
        onClick: () => onChange(true),
      },
      {
        content: intl.formatMessage({
          id: 'SelectDeselectAllMenu.deselectAll',
          defaultMessage: 'Deselect All',
          description: 'Menu option to deselect all items',
        }),
        onClick: () => onChange(false),
      },
    );

    return items;
  }

  return (
    <ActionsMenu
      aria-label={`${name} select menu`}
      title={intl.formatMessage(
        {
          id: 'SelectDeselectAllMenu.title',
          defaultMessage: '{name} select menu',
          description:
            'Title for select/deselect menu. Example: name = "Document Name"',
        },
        { name },
      )}
      id={id}
      smallIcon
      icon="chevronDown"
      items={getSelectAllMenuItems()}
    />
  );
}
